"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { getFocusWithinAccessibleStyles as t } from "../../../utils/styles.mjs";
import { Text as n } from "../Text/Text.mjs";
import { forwardRef as r, useEffect as i, useRef as a, useState as o } from "react";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
import { cva as l } from "class-variance-authority";
//#region src/components/atoms/TextAreaInput/TextAreaInput.tsx
var u = l("\n    group\n    w-full\n    flex\n    flex-col\n    min-h-0\n    p-2\n    gap-3\n    rounded-md\n    \n    bg-white\n    \n    dark:bg-neutral-dark-200\n    ", {
	variants: { state: {
		default: "",
		error: "border border-red-400"
	} },
	defaultVariants: { state: "default" }
}), d = l("\n    block\n    w-full\n    field-sizing-content\n    overflow-y-auto\n\n    disabled:cursor-not-allowed\n    disabled:opacity-60\n    min-h-[94px] \n    min-w-[240px]\n    text-xs\n    leading-[var(--text-xs--line-height)]\n\n    bg-inherit\n    text-gray-900 \n    placeholder:text-gray-500 \n\n    dark:bg-inherit\n    dark:text-neutral-dark-1000\n    dark:placeholder:text-neutral-dark-600\n    ", {
	variants: { resize: {
		vertical: "resize-y",
		horizontal: "resize-x",
		all: "resize",
		none: "resize-none"
	} },
	defaultVariants: { resize: "vertical" }
}), f = l("", {
	variants: { state: {
		default: "dark:text-neutral-dark-600",
		error: "text-red-100"
	} },
	defaultVariants: { state: "default" }
}), p = r(({ className: r, wrapperClassName: l, textAreaClassName: p, state: m = "default", resize: h = "vertical", showCount: g = !1, keyboardFocusOnly: _ = !1, helperText: v = "", maxLength: y, onFocus: b, onBlur: x, value: S, ...C }, w) => {
	let [T, E] = o(!1), D = a("mouse"), O = S ? String(S).length : 0;
	i(() => {
		if (!_) return;
		let e = () => {
			D.current = "mouse";
		}, t = (e) => {
			e.key === "Tab" && (D.current = "keyboard");
		};
		return document.addEventListener("mousedown", e), document.addEventListener("keydown", t), () => {
			document.removeEventListener("mousedown", e), document.removeEventListener("keydown", t);
		};
	}, [_]);
	let k = (e) => {
		b?.(e), _ && D.current === "keyboard" && E(!0);
	}, A = (e) => {
		x?.(e), _ && E(!1);
	}, j = _ ? e("focus:outline-none focus:ring-0 focus:border-none", "focus-visible:outline-none focus-visible:ring-0 focus-visible:border-none", T && "!outline-solid !outline-2 !outline-offset-2 !outline-white !ring-2 !ring-blue-600") : t();
	return /* @__PURE__ */ c("div", {
		className: e("flex flex-col gap-2 min-h-0", l),
		children: [/* @__PURE__ */ c("div", {
			className: e(u({ state: m }), j, r),
			"data-testid": "text-area-input-container",
			children: [/* @__PURE__ */ s("textarea", {
				ref: w,
				className: e(d({ resize: h }), "focus:outline-none focus:ring-0 focus:border-none", "focus-visible:outline-none focus-visible:ring-0 focus-visible:border-none", p),
				onFocus: k,
				onBlur: A,
				maxLength: y,
				value: S,
				...C
			}), g && y && /* @__PURE__ */ c(n, {
				fontSize: "xs",
				fontWeight: "regular",
				className: "dark:text-neutral-dark-600 text-right pr-2",
				children: [
					O,
					"/",
					y,
					" characters"
				]
			})]
		}), v && /* @__PURE__ */ s(n, {
			fontSize: "xs",
			fontWeight: "regular",
			className: f({ state: m }),
			children: v
		})]
	});
});
p.displayName = "TextAreaInput";
//#endregion
export { p as TextAreaInput };
